// redux
import { combineReducers } from 'redux';
// types
import { SET_MENUS_DATA } from './types';

export function MenusData(state = { Data: [] }, action) {
    switch (action.type) {
        case SET_MENUS_DATA:
            if (action.Data === null) {
                action.Data = [];
            }
            return { Data: action.Data };

        default:
            return state;
    }
}

const Reducer = combineReducers({
    MenusData,
});

export default Reducer;
